module.exports = __webpack_public_path__ + "img/icon-unplugged.1723fe3f.svg";